module.exports = __webpack_public_path__ + "img/36.3c8b8d28.png";